import { X, Sparkles, Clock } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';

const SpecialOfferBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
    setIsVisible(false);
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 via-amber-600 to-orange-500 text-white py-3 px-4 relative overflow-hidden">
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.1) 10px, rgba(255,255,255,.1) 20px)'
        }}></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-3 flex-1">
            <Sparkles className="w-5 h-5 animate-pulse" />
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-bold text-lg">Limited Time Offer!</span>
              <span className="hidden sm:inline">Get 20% OFF on bookings for 3+ nights</span>
              <div className="flex items-center gap-1 bg-white/20 px-2 py-1 rounded text-sm">
                <Clock className="w-3 h-3" />
                <span className="font-semibold">Ends in 2 days</span>
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button 
              onClick={scrollToBooking}
              size="sm"
              className="bg-white text-amber-600 hover:bg-gray-100 font-semibold"
            >
              Book Now & Save
            </Button>
            <button
              onClick={() => setIsVisible(false)}
              className="p-1 hover:bg-white/20 rounded transition-colors"
              aria-label="Close banner"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferBanner;
